/**
 * Взято из lead-realtor-form /v1/get-form
 * question: dealTypeEx
 * @see question.answers
 * */
export var EDealType;

(function (EDealType) {
  EDealType["Buy"] = "buy";
  EDealType["Sale"] = "sale";
  EDealType["SellToBuy"] = "sellToBuy";
  EDealType["Tenant"] = "tenant";
  EDealType["Rent"] = "rent";
})(EDealType || (EDealType = {}));

export var dealTypeSelectorOptions = [{
  value: EDealType.Buy,
  selectedLabel: 'Купить',
  label: 'Купить'
}, {
  value: EDealType.Sale,
  selectedLabel: 'Продать',
  label: 'Продать'
}, {
  value: EDealType.SellToBuy,
  selectedLabel: 'Продать, чтобы купить',
  label: 'Продать, чтобы купить'
}, {
  value: EDealType.Tenant,
  selectedLabel: 'Снять',
  label: 'Снять'
}, {
  value: EDealType.Rent,
  selectedLabel: 'Сдать',
  label: 'Сдать'
}];